(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };

  register('package-thumbnails', ({ root, listen }) => {
    const thumbnailWidths = [48, 64, 76, 96];
    const variantImageSource = (variant) => {
      const image = variant?.featured_image || variant?.featured_media?.preview_image;
      if (typeof image === 'string') return image;
      return image?.src || image?.url || '';
    };
    const imageUrlAtWidth = (source, width) => {
      if (!source) return '';
      try {
        const sourceUrl = new URL(source, window.location.origin);
        sourceUrl.searchParams.set('width', String(width));
        return sourceUrl.toString();
      } catch (error) {
        const joiner = source.includes('?') ? '&' : '?';
        return `${source}${joiner}width=${width}`;
      }
    };
    const updateThumbnail = (card, kind, variant) => {
      const frame = card.querySelector(`[data-package-thumbnail="${kind}"]`);
      if (!frame || frame.dataset.thumbnailStatic === 'true') return;
      const image = frame.querySelector('img');
      const source = variantImageSource(variant);
      if (!image || !source) return;
      image.src = imageUrlAtWidth(source, thumbnailWidths[thumbnailWidths.length - 1]);
      image.srcset = thumbnailWidths.map((width) => `${imageUrlAtWidth(source, width)} ${width}w`).join(', ');
    };
    const updateCard = ({ card, state } = {}) => {
      if (!(card instanceof HTMLElement) || !state) return;
      updateThumbnail(card, 'harness', state.mainVariant);
      updateThumbnail(card, 'bungee', state.bungeeVariant);
      updateThumbnail(card, 'collar', state.collarVariant);
    };

    listen(root, 'swv5:package-card-state', (event) => updateCard(event.detail));
  });
})();
